export namespace MapStyles {
  export const SATELLITE =
    'mapbox://styles/mapbox/satellite-streets-v12' as const;
}
